import {AfterViewInit, Component, Directive, Input, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';

import {ToastrService} from 'ngx-toastr';
import {language} from '../../../language/vn';
import {CommandUtil} from '../../../global/commandutil';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {CalendarNewsService} from '../../../service/calendar/service-calendarnews';
import {CalendarNewsLog} from '../../../models/calendar/calendarnewslog';
@Component({
  templateUrl: './lichsu.component.html',
  encapsulation: ViewEncapsulation.None

})
export class LichSuLichCongTacComponent implements OnInit, AfterViewInit {
  public language = language;
  public id: number = 0;
  public  onClose: Subject<boolean>;
  public calendarNewsLogList: CalendarNewsLog[] = [];
  constructor(
    public calendarNewsService: CalendarNewsService,
    public toastr: ToastrService,
    public datepipe: DatePipe,
    public commandUtil: CommandUtil,
    public bsModalService: BsModalService,
    public _bsModalRef: BsModalRef
  ) {
  }
  ngAfterViewInit() {
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.onClose = new Subject();

  }


  public show(id) {
    this.id = id;
    this.loadLog();

  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  public loadLog()
  {
    this.calendarNewsService.findByLogId(this.id).subscribe( data => this.calendarNewsLogList = data);
  }



}

